import { initialStateGlobal } from "./initializers"

export default function selector(state=initialStateGlobal, action) {

    let newState = {...state};

    switch (action.type) {
  
        case 'GLOBAL_SET_STATE':
            Object.keys(action.object).forEach((key) => newState[key] = action.object[key]);                
            return newState;

        case 'SET_TIME_RANGE':
            newState.periodstart = action.periodstart;
            newState.periodend = action.periodend;            
            return newState;

        case 'SET_AREA_SCALE':
            newState.areascale = action.areascale;
            return newState;
    
        default:
            return state;
    }
}
